define(
  'Item.KeyMapping.Extension',
  [
    'Item.KeyMapping',
    'ItemName.Helper',
    'underscore'
  ],
  function (
    ItemKeyMapping,
    ItemNameHelper,
    _
  ) {
    'use strict';

    function composeItemName(item) {
      return ItemNameHelper.composeName({
        displayName: item.get('storedisplayname2'),
        description: item.get('storedescription'),
        salesDescription: item.get('salesdescription'),
        sku: item.get('itemid')
      });
    }

    _.extend(ItemKeyMapping, {
      getKeyMapping: _.wrap(ItemKeyMapping.getKeyMapping, function (fn) {
        var mapping = fn.apply(this, _.toArray(arguments).slice(1));

        mapping._name = function (item) {
          var itemId = item.get('itemid') || '';
          var parent = item.get('_matrixParent');

          if (parent.get('internalid')) {
            var matches = itemId.match(/:(.*)/);
            var childName = matches && matches[1];

            return childName || composeItemName(parent) || itemId;
          }

          return composeItemName(item);
        };

        mapping._pageHeader = function (item) {
          return item.get('_name');
        };

        mapping._pageTitle = function (item) {
          return item.get('pagetitle') || item.get('_name');
        };

        return mapping;
      })
    });

    return ItemKeyMapping;
  });
